<template>
  <section class="toolbar bg-gray-900">
    <div class="container py-2">
      <div class="d-flex justify-content-between">
        <ncc-toolbar-icon
          icon="ncc-arrow-left"
          :class="{'button--disabled': !qna.prev}"
          @click="goto('prev')"
        />
        <ncc-toolbar-icon icon="ncc-camera" :class="{'button--active': isTabVideobarActive}" @click="showVideobar"/>
        <ncc-toolbar-icon icon="ncc-notes" :class="{'button--active': isTabNotesActive}" @click="showNotes"/>
        <ncc-toolbar-icon icon="ncc-chat" :class="{'button--active': isTabPrayerActive}" @click="showPrayer"/>
        <ncc-toolbar-icon
          icon="ncc-arrow-right"
          :class="{'button--disabled': !qna.next}"
          @click="goto('next')"
        />
      </div>
    </div>
  </section>
</template>

<script>
  import NccToolbarIcon from './NccToolbarIcon';

  export default {
    name: "NccQuestionToolbar",
    components: {
      NccToolbarIcon
    },
    computed: {
      qna() {
        return this.$store.getters['selectedQuestion'];
      },
      isTabVideobarActive() {
        return this.$store.getters['showVideoBar'];
      },
      isTabNotesActive() {
        return this.$store.getters['showNotes'];
      },
      isTabPrayerActive() {
        return this.$store.getters['showPrayer'];
      }
    },
    methods: {
      goto(direction) {

        if (this.qna[direction]) {
          const url = this.qna[direction];
          this.$store.dispatch('fetchQuestion', {postUrl: this.qna[direction] + '?json=1'})
            .then(({seoTitle}) => {
              this.hideAll();
              document.title = seoTitle;
              history.pushState(null, seoTitle, url);
            })
        }
      },
      hideAll() {
        this.$store.commit('SET_SHOW_ANSWER', false);
        this.$store.commit('SET_SHOW_VIDEOBAR', false);
        this.$store.commit('SET_SHOW_COMMENT', false);
        this.$store.commit('SET_SHOW_PRAYER', false);
      },
      showVideobar() {
        this.hideAll();
        this.$store.commit('SET_SHOW_VIDEOBAR', true);

        this.scrollToY('qna-video')
      },
      showNotes() {
        this.hideAll();
        this.$store.commit('SET_SHOW_COMMENT', true)

        this.scrollToY('comment-bar')
      },
      showPrayer() {
        this.hideAll();
        this.$store.commit('SET_SHOW_PRAYER', true)

        this.scrollToY('prayer-bar')
      },
      scrollToY(elmId) {
        // Delay because element is not yet available
        setTimeout(() => {
          const elm = document.getElementById(elmId);

          if (elm) {
            window.scrollToY(elm.offsetTop, 2500);
          }

          // window.location.href = window.location.pathname + elmId;
        }, 250);
      }
    }
  }
</script>

<style scoped>
  .toolbar {
    padding: 0 1rem;
  }
</style>
